import React, { useEffect, createElement } from 'react';
import { SalesPage } from './components/SalesPage';
import { UpsellPage } from './components/UpsellPage';
import { UpsellPage2 } from './components/UpsellPage2';
import { DownsellPage1 } from './components/DownsellPage1';
import { ThankYouPage } from './components/ThankYouPage';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export function App() {
  useEffect(() => {
    if (!window.fbq) {
      const n: any = window.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!window._fbq) window._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = document.createElement('script');
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(t);
    }
    window.fbq('init', '1280697337448000');
    window.fbq('track', 'PageView');
  }, []);
  const path = window.location.pathname.replace(/\/$/, '') || '/';
  if (path === '/up1') {
    return <UpsellPage data-id="element-17" />;
  }
  if (path === '/up2') {
    return <UpsellPage2 data-id="element-18" />;
  }
  if (path === '/dw1') {
    return <DownsellPage1 data-id="element-19" />;
  }
  if (path === '/gracias') {
    return <ThankYouPage data-id="element-20" />;
  }
  return <SalesPage data-id="element-21" />;
}